export const ctrTINTypes = [
  { label: 'EIN', value: 'EIN' },
  { label: 'SSN-ITIN', value: 'SSN-ITIN' },
  {
    label: 'Foreign',
    value: 'Foreign'
  }
]
